// frontend/src/components/AdminUpload.js
import React, { useState } from 'react';
import api from '../services/api';
import NoPreview from './NoPreview';

function AdminUpload({ onUploadSuccess }) {
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      // Create a preview URL for the video
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || !title) return;

    const formData = new FormData();
    formData.append('title', title);
    formData.append('video', file);

    try {
      setUploading(true);
      setUploadProgress(0);
      
      const response = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        }
      });
      
      if (onUploadSuccess) onUploadSuccess(response.data);
      setTitle('');
      setFile(null);
      setPreviewUrl(null);
      setUploadProgress(0);
    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container">
      <h2 className="section-header">Upload New Content</h2>
      
      <div className="upload-section">
        <div className="upload-form">
          <form onSubmit={handleUpload}>
            <div className="form-group">
              <label className="form-label">Video Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter a descriptive title"
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">Video File</label>
              <div className="file-upload">
                <input
                  type="file"
                  onChange={handleFileChange}
                  accept="video/*"
                  required
                />
                <i className="fas fa-cloud-upload-alt"></i>
                <div className="file-upload-text">
                  <h4>Drag & Drop or Click to Upload</h4>
                  <p>MP4, MOV, or AVI files (max 500MB)</p>
                </div>
              </div>
            </div>
            
            {uploading && (
              <div className="form-group">
                <label className="form-label">Upload Progress</label>
                <div className="progress-container">
                  <div 
                    className="progress-bar" 
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
                <p className="text-center">{uploadProgress}% Uploaded</p>
              </div>
            )}
            
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={uploading || !file || !title}
            >
              {uploading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Uploading...
                </>
              ) : (
                <>
                  <i className="fas fa-upload"></i> Upload Video
                </>
              )}
            </button>
          </form>
        </div>
        
        <div className="preview-section">
          {previewUrl ? (
            <div className="video-preview">
              <video 
                src={previewUrl} 
                controls 
                width="100%" 
                height="auto"
              />
              <p className="file-info">
                <strong>File:</strong> {file?.name} ({(file?.size / (1024 * 1024)).toFixed(2)} MB)
              </p>
            </div>
          ) : (
            <NoPreview />
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminUpload;
